import { render } from "./Provenance.vue?vue&type=template&id=e48afbea&scoped=true"
import script from "./Provenance.vue?vue&type=script&lang=js"
export * from "./Provenance.vue?vue&type=script&lang=js"

import "./Provenance.vue?vue&type=style&index=0&id=e48afbea&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48afbea"]])

export default __exports__